// classes
import EventEmitter from "./EventEmitter";

export default class Time extends EventEmitter
{
    constructor()
    {
        // override
        super()

        // options
        this.start = Date.now()
        this.previousFrame = this.start
        this.elapsedTime = 0
        this.deltaTime = 16

        // on every frame call
        window.requestAnimationFrame( () => 
        {
            this.tick()
        } )
    }

    tick()
    {
        const currentTime = Date.now()

        this.deltaTime = currentTime - this.previousFrame
        this.elapsedTime = currentTime - this.start

        this.previousFrame = currentTime

        window.requestAnimationFrame( () => 
        {
            this.tick()
        } )

        // emitt tick...
        this.trigger( "tick" )
    }
}